import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class CoreList extends Block {
  render() {
    const { block } = this.props;
    return <div dangerouslySetInnerHTML={{ __html: block.originalContent }} />;
  }
}
class CoreListFactory {
  get type() {
    return "core/list";
  }

  create(props) {
    return <CoreList {...props} />;
  }
}

export default CoreListFactory;
